import { TextField, MenuItem, CardContent } from '@mui/material';
import React from 'react';
import { ActiveProjects, projectLimitInfo } from '@shared/models/paywall.model';

export const PaywallCardActiveProjectsSelect = ({
  selected,
  onSelect,
}: {
  selected: ActiveProjects;
  onSelect: (selected: ActiveProjects) => void;
}) => {
  return (
    <CardContent sx={{ paddingY: 0 }}>
      <TextField
        select
        fullWidth
        value={selected}
        onChange={(event) => onSelect(event.target.value as ActiveProjects)}
        size="small"
      >
        {projectLimitInfo.map(({ activeProjects }) => (
          <MenuItem key={activeProjects} value={activeProjects}>
            {activeProjects} active projects
          </MenuItem>
        ))}
      </TextField>
    </CardContent>
  );
};
